<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                        cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Login') }}</h1>

                        <ValidationObserver ref="observer">
                          <v-form v-model="valid" @submit.prevent="handleSubmit">

                            <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required" v-slot="{ errors }">
                              <v-text-field
                                  v-model="email"
                                  :error-messages="errors[0]"
                                  :label="$t('labels.Email')"
                                  required
                                  autocapitalize="none"
                              ></v-text-field>
                            </ValidationProvider>

                            <ValidationProvider vid="password" :name="$t('labels.Password')" rules="required" v-slot="{ errors }">
                              <v-text-field
                                  v-model="password"
                                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                  :type="showPassword ? 'text' : 'password'"
                                  :error-messages="errors[0]"
                                  :label="$t('labels.Password')"
                                  required
                                  autocapitalize="none"
                                  @click:append="showPassword = !showPassword"
                              ></v-text-field>
                            </ValidationProvider>

                            <div class="d-flex justify-end">
                              <v-btn rounded color="primary" elevation="0" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                            </div>

                          </v-form>
                        </ValidationObserver>

                        <v-row>
                          <v-col
                              md="6"
                              offset-md="3"
                          >
                            <router-link to="/sign-up">Create account</router-link> | <router-link to="/reset-password">{{ $t('links.Reset password') }}</router-link>
                          </v-col>
                        </v-row>

                    </v-col>

                </v-row>

            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    
    import { mapState, mapActions } from 'vuex'
    import { store } from '../store';

    import { extend } from 'vee-validate';
    import { required, email, min } from 'vee-validate/dist/rules';

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";

    // Add the required rule
    extend('required', required);

    // Add the email rule
    extend('email', email);

    export default {
        name: "Login",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Login'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data: () => ({
            email: '',
            password: '',
            valid: false,
            showPassword: false,
        }),
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;
        },
        computed: {
            ...mapState({
              brand: state => state.brand,
              brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            userIsOrganisation() {
                return store.getters.userHasRole(['organisation'])
            }
        },
        methods: {
            ...mapActions('account', ['login', 'logout']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            authenticated () {
                return store.state.authenticated
            },
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            async handleSubmit () {

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {
                    const { email, password } = this;
                    if (email && password) {
                        this.login({ email, password }).then()
                    }
                }

            }
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    /*.login-form {*/
    /*    background-color: rgba(0, 0, 0, 0.7);*/
    /*}*/
</style>
